import type { HasMenuId } from '../../types';

export const getMenuIds = <T extends HasMenuId>(items: T[]) => items.map((item) => item.menuId);
